/**
 * 获取首页数据
 */
import request from "_private/utils/request";

/* 广州市城市冷链配送监控看板 */

// 城市冷链配送企业排行
export function companyAndVehicleCount(data) {
  return request({
    url: "/board/guangzhouMonitor/companyAndVehicleCount",
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 获取运营走势数据
export function fetchCenterLeftData(data) {
  return request({
    url: `/board/guangzhouMonitor/getOperatingTrendDryAndCold?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}

// 广州市限行区域晚高峰冷藏车运行情况（A,B,C）
export function getStorageTonnageOrderNew(data) {
  return request({
    url: "/board/guangzhouMonitor/getStorageTonnageOrderNewDryAndCold",
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 获取城市冷链配送车辆使用率及限行区域行驶数据
export function getBottomLeftData(data) {
  return request({
    url: `/board/guangzhouMonitor/vehicleUtilizationRateDry?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 获取城市冷链配送车辆使用率及限行区域行驶数据
export function vehicleUtilizationRate(data) {
  return request({
    url: `/board/guangzhouMonitor/vehicleUtilizationRate?userId=${data.userId}`,
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 进入广州重点限行区域情况
export function getKeyRestrictAreaInfo(data) {
  return request({
    url: "/board/guangzhouMonitor/getKeyRestrictAreaInfoDryAndCold",
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 车辆、企业等汇总数据
export function fetchMapData(data) {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/findMapLonLatDry?transType=5",
    data
  });
}
// 实时查询各区县下企业、车辆、冷库、冷柜个数接口
export function FetchNumberByAreaName(data) {
  return request({
    headers: {
      type: "json"
    },
    method: "post",
    url: "/board/home/findNumberByAreaNameDry?transType=5",
    data
  });
}
